"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "DynamicGmap", {
  enumerable: true,
  get: function () {
    return _DynamicGmap.default;
  }
});
_Object$defineProperty(exports, "MarkerState", {
  enumerable: true,
  get: function () {
    return _markerConstants.MarkerState;
  }
});
_Object$defineProperty(exports, "StaticGmap", {
  enumerable: true,
  get: function () {
    return _StaticGmap.default;
  }
});
_Object$defineProperty(exports, "ZINDEXES", {
  enumerable: true,
  get: function () {
    return _markerConstants.ZINDEXES;
  }
});
exports.default = void 0;
_Object$defineProperty(exports, "getCenterFromCorners", {
  enumerable: true,
  get: function () {
    return _map.getCenterFromCorners;
  }
});
_Object$defineProperty(exports, "getMapContainerCorners", {
  enumerable: true,
  get: function () {
    return _map.getMapContainerCorners;
  }
});
_Object$defineProperty(exports, "getMarkerIconForState", {
  enumerable: true,
  get: function () {
    return _map.getMarkerIconForState;
  }
});
_Object$defineProperty(exports, "resetMarkersState", {
  enumerable: true,
  get: function () {
    return _map.resetMarkersState;
  }
});
var _DynamicGmap = _interopRequireDefault(require("./components/DynamicGmap/DynamicGmap"));
var _StaticGmap = _interopRequireDefault(require("./components/StaticGmap/StaticGmap"));
var _map = require("./lib/map.utils");
var _markerConstants = require("./lib/markerConstants");
// for backwards compatibility. Prefer to use the named exports going forwards.
var _default = exports.default = _DynamicGmap.default;